import { Helmet } from 'react-helmet-async';
import { useState, useEffect } from 'react';
// @mui
import { Alert, Card, Container, Grid, CardContent, Typography, Stack, Link } from '@mui/material';
import api from 'src/utils/api';

// ----------------------------------------------------------------------

// Хелпер для витягування ID з посилання
const getYouTubeID = (url) => {
  if (!url) return '';
  if (!url.includes('/') && url.length === 11) return url;
  
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  
  return (match && match[2].length === 11) ? match[2] : url;
};

export default function IntroPage() {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    api.get('video-api?filter[type]=0&per-page=50')
      .then((result) => {
        setVideos(result);
      })
      .catch(() => {
        setVideos([]);
      });
  }, [])

  return (
    <>
      <Helmet>
        <title> Інструкції | Lala English </title>
      </Helmet>

      <Alert severity="error" sx={{ mb: 5, pl: 3 }}>Відео-інструкції по роботі з платформою.</Alert>
      <Container>

        <Grid container spacing={3}>
          {!videos.length ? <Typography variant="body2" sx={{ p: 3.5 }}>Ще немає відео</Typography> : null}
          {videos.map((video, index) => {
            const videoId = getYouTubeID(video.url);
            
            return (
              <Grid key={video.id} item xs={12} sm={6} md={4}>
                <Card sx={{ position: 'relative', display: 'flex', flexDirection: 'column', height: '100%' }}>
                  
                  {/* Замінили бібліотеку на чистий iframe */}
                  <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                    <iframe
                      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                      src={`https://www.youtube.com/embed/${videoId}`}
                      title={video.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      loading="lazy" // Ліниве завантаження для пришвидшення сторінки
                    />
                  </div>

                  <CardContent sx={{ pt: 2, flexGrow: 1 }}>
                    <Typography variant="subtitle2">{index+1}. {video.title}</Typography>
                    {video.link ? (
                      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mt: 1 }}>
                        <Link href={video.link} target="_blank" rel="noopener noreferrer">
                          Презентація
                        </Link>
                      </Stack>
                    ) : null}
                    {video.text ? <Typography variant="body2" sx={{ pt: 1 }}>{video.text}</Typography> : null}
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </>
  );
}